export enum Locales {
  ru = "ru",
  kz = "kz",
}

export const DEFAULT_LOCALE = Locales.ru;
